var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import cls from 'classnames';
import { Popup, tools } from 'rcm-mobile';
import './style/index.scss';
let getUuid;
let rootElement;
const dialogInstance = {};
/**
 * @author sayll
 * @version 0.0.1
 */
export default class Dialog extends React.PureComponent {
    render() {
        const _a = this.props, { prefixCls, className, children, title, type, buttons, getSender, onBeforeOk, onOk, onCancel } = _a, resetProps = __rest(_a, ["prefixCls", "className", "children", "title", "type", "buttons", "getSender", "onBeforeOk", "onOk", "onCancel"]);
        let operateButtons = [];
        if (buttons) {
            for (const key in buttons) {
                if (buttons[key] === true) {
                    operateButtons.push(<a key={key} className={`${prefixCls}-operate-ok`} href="javascript:;" onClick={() => this.handleOk()}>{key}</a>);
                }
                else {
                    operateButtons.push(<a key={key} className={`${prefixCls}-operate-cancel`} href="javascript:;" onClick={() => {
                        if (buttons[key]) {
                            // @ts-ignore
                            buttons[key](this);
                            this.handleDestroy();
                        }
                        else {
                            this.handleCancel();
                        }
                    }}>{key}</a>);
                }
            }
        }
        else {
            operateButtons.push(<a key="onOk" href="javascript:;" className={`${prefixCls}-operate-ok`} onClick={() => this.handleOk()}>确定</a>);
            type === 'confirm' && operateButtons.push(<a key="onCancel" href="javascript:;" className={`${prefixCls}-operate-cancel`} onClick={() => this.handleCancel()}>取消</a>);
        }
        return (<div className={cls(`${prefixCls}`, className)} {...resetProps}>
        <div className={`${prefixCls}-container`}>
          <div className={`${prefixCls}-content`}>
            {title ?
            <h2 className={`${prefixCls}-title`}>{title}</h2> : null}
            <div className={cls(`${prefixCls}-message`, { 'x-gray-3': !title })}>{children}</div>
          </div>
          <div className={`${prefixCls}-operate`}>{operateButtons}</div>
        </div>
      </div>);
    }
    handleDestroy() {
        this.props.getSender().destroy();
    }
    handleOk() {
        return __awaiter(this, void 0, void 0, function* () {
            const { onOk, onBeforeOk } = this.props;
            if (onBeforeOk && (yield onBeforeOk(this)) === false)
                return;
            onOk && onOk(this);
            this.handleDestroy();
        });
    }
    handleCancel() {
        const { onCancel } = this.props;
        onCancel && onCancel(this);
        this.handleDestroy();
    }
    static create(content, title, callback, options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!rootElement) {
                rootElement = document.createElement('div');
                rootElement.className = `${Dialog.defaultProps.prefixCls}-root`;
                document.body.appendChild(rootElement);
            }
            getUuid = getUuid || tools.helper.getUuidFn(Dialog.defaultProps.prefixCls);
            const key = getUuid();
            const _a = options || {}, { title: _title, type, onBeforeOk, onOk, onCancel, buttons } = _a, resetProps = __rest(_a, ["title", "type", "onBeforeOk", "onOk", "onCancel", "buttons"]);
            if (options) {
                title = _title || title;
                callback = onOk || callback;
            }
            const sender = yield Popup.create(Object.assign({ content: () => <Dialog type={type} title={title} getSender={() => sender} buttons={buttons} onBeforeOk={onBeforeOk} onOk={callback} onCancel={onCancel}>{tools.helper.getReactNode(content)}</Dialog>, mask: true }, resetProps, { rootElement }));
            return dialogInstance[key] = sender;
        });
    }
    /**
     * 消息框
     * @public
     * */
    static alert(content, title, callback, options) {
        return Dialog.create(content, title, callback, Object.assign({ type: 'alert' }, options));
    }
    /**
     * 对话框
     * @public
     * */
    static confirm(content, title, callback, options) {
        return Dialog.create(content, title, callback, Object.assign({ type: 'confirm' }, options));
    }
    /**
     * 卸载所有Dialog
     * @public
     * */
    static destroy() {
        return __awaiter(this, void 0, void 0, function* () {
            let sender;
            for (let key in dialogInstance) {
                sender = yield dialogInstance[key];
                sender.destroy();
                delete dialogInstance[key];
            }
        });
    }
}
Dialog.defaultProps = {
    prefixCls: 'x-dialog'
};
